import { inject, Injectable } from '@angular/core';

import {
  TellentAssistantAnalyticsService,
  TellentAssistantService,
  type AssistantNewConversationTrigger,
  type AssistantWindowMode,
} from '@core/tellent-assistant-logic';

@Injectable({ providedIn: 'root' })
export class ChatPanelAnalyticsService {
  private readonly analytics = inject(TellentAssistantAnalyticsService);
  private readonly assistantService = inject(TellentAssistantService);

  public messageSent(text: string): void {
    this.analytics.messageSent(text.length, this.assistantService.messages().length);
  }

  public starterClicked(text: string): void {
    this.analytics.starterClicked(text);
  }

  public newConversationClicked(trigger: AssistantNewConversationTrigger): void {
    this.analytics.newConversationClicked(trigger);
  }

  public conversationLoadedFromHistory(): void {
    this.analytics.conversationLoadedFromHistory();
  }

  public hamburgerToggled(wasOpen: boolean): void {
    if (!wasOpen) this.analytics.hamburgerMenuOpened();
  }

  public windowClosed(): void {
    this.analytics.windowClosed();
  }

  public windowMinimized(): void {
    this.analytics.windowMinimized();
  }

  public fullscreenModeChanged(mode: AssistantWindowMode): void {
    this.analytics.fullscreenModeChanged(mode);
  }

  public windowDragged(): void {
    this.analytics.windowDragged();
  }

  public copyToClipboardClicked(): void {
    this.analytics.copyToClipboardClicked();
  }

  public feedbackGiven(feedback: 'up' | 'down'): void {
    this.analytics.feedbackThumbClicked(feedback === 'up' ? 'positive' : 'negative');
  }

  public textInputFocused(): void {
    this.analytics.textInputFocused();
  }
}
